import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import MaterialTable from 'material-table';

import UserProfile from "views/Pages/UserProfile"
import ProviderInfo from "views/Pages/ProviderInfo.jsx"
import RegisterPatient from "views/Pages/RegisterPatient"
import Invitation from 'views/Components/Invitation.jsx'
import Patients from "views/Pages/Patients"
import Agreement from "views/Pages/SignupSteps/Agreement"

import Danger from "components/Typography/Danger.jsx";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import FormControl from "@material-ui/core/FormControl/FormControl";
import Datetime from "react-datetime";
// @material-ui/icons
import AttachMoney from "@material-ui/icons/AttachMoney";
import PersonIcon from "@material-ui/icons/Person";
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";
import MailOutline from "@material-ui/icons/MailOutline";
import People from "@material-ui/icons/People";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import FileUpload from "components/CustomUpload/FileUpload.jsx";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import axios from "axios";
import { addressToOneLine, getApiHeaders, handleApiResponse, phoneToDisplay, checkForCellPhone } from "../../assets/helpers/apiHelper";
import { verifyDecimal, validateDateFormatAndOrder } from "../../assets/helpers/formHelper";
import { API_ROOT } from 'api-config';

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { convertToCurrency, convertToDisplayDate, updateTableRow } from "../../assets/helpers/dataHelper";
import { getUserGroups } from "../../assets/helpers/utilityHelper";

var moment = require('moment');
const tableStyle = require('../../assets/style/tableStyle.json');
var tableOptions = require('../../assets/style/tableOptions.json');
tableOptions = JSON.parse(JSON.stringify(tableOptions));
var shortTableOptions = JSON.parse(JSON.stringify(tableOptions));
shortTableOptions.pageSize = 5;
shortTableOptions.toolbar = false;
shortTableOptions.paging = false;
const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  filterLabel: {
    marginTop: "15px"
  },
  ...sweetAlertStyle,
  ...extendedFormsStyle
};

var loadingData = []
loadingData['id'] = 0
loadingData['transactionDatetime'] = 'loading...'
loadingData['transactionAmount'] = 'loading...'
loadingData = [loadingData]

const patientTableDataLoading = [{
  id: 0, name: 'loading...', firstName: 'loading...',
  lastName: 'loading...', address: 'loading...', addressCity: 'loading...',
  addressState: 'loading...', addressZip: 'loading...', phone: 'loading...',
  openAccount: 'loading...', actions: 'loading...'
}]

var userGroups = getUserGroups()

class ReactTables extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.enterCharge = this.enterCharge.bind(this);
    var viewType = ''
    var editByOrg = true
    var pageTitle = 'Patients'
    var registerViewType = ''
    var orgType = 'provider'
    var groupType = ''
    var includeSelfInPatientQuery = false
    var employerId = ''
    var userId = sessionStorage.getItem('userId')
    var actorOrgType = ''
    if (props.viewType) {
      viewType = props.viewType
    }
    if (props.overrideUserId) {
      userId = props.overrideUserId
    }
    if (userGroups.indexOf('patient') >= 0 || viewType === 'patient') {
      viewType = 'patient'
      pageTitle = 'Members'
      registerViewType = 'patient'
      editByOrg = false
      orgType = 'patient'
      groupType = 'family'
      includeSelfInPatientQuery = true
    } else if (userGroups.indexOf('employer') >= 0) {
      viewType = 'employer'
      pageTitle = 'Members'
      registerViewType = 'patient'
      editByOrg = false
      orgType = 'employer'
      groupType = 'employer'
      employerId = sessionStorage.getItem('userId')
    }
    if (userGroups.indexOf('patient') >= 0) {
      actorOrgType = 'patient'
    } else if (userGroups.indexOf('organization') >= 0) {
      actorOrgType = 'provider'
    }
    var customInputStyle = {marginTop: "24px"}
    this.state = {
      userId: userId,
      patientTableData: patientTableDataLoading,
      patientTableRows: 10,
      accountingPopup: '',
      pendingCharges: [],
      recentCharges: [],
      numPendingCharges: 5,
      numRecentCharges: 1,
      alert: '',
      chargeDialogOpen: false,
      dialogName: '',
      dialogUserId: '',
      dialogPhone: '',
      feeTable: [],
      feeArray: {},
      chargeFee: '',
      chargeEntryDisabled: false,
      nestEggBalance: '',
      pendingBalance: '',
      combinedNestEggPendingBalance: '',
      nestEggBalanceWithBonus: '',
      combinedNestEggPendingBalanceWithBonus: '',
      nestEggBonusAmount: '',
      patientDialogueOpen: false,
      includeClosedAccounts: false,
      includeClosedAccountsButtonDisabled: true,
      accountStatusMessage: '',
      signedAgreementStartDate: '',
      signedAgreementEndDate: '',
      canceledStartDate: '',
      canceledEndDate: '',
      validSignedAgreementStartDate: '',
      validSignedAgreementEndDate: '',
      validCanceledStartDate: '',
      validCanceledEndDate: '',
      showFilterOptions: false,
      showingFilteredSubset: false,
      pageTitle: pageTitle,
      registerDialogueOpen: false,
      registerViewType: registerViewType,
      providerId: '',
      editByOrg: editByOrg,
      orgType: orgType,
      inviteDialogueOpen: false,
      groupType: groupType,
      includeSelfInPatientQuery: includeSelfInPatientQuery,
      viewType: viewType,
      employerId: employerId,
      uploadSpreadsheetDialogueOpen: false,
      isPrimaryProvider: '',
      familyDialogueOpen: false,
      familyUserId: '',
      actorOrgType: actorOrgType,
      agreementDialogueOpen: false,
      signForUserId: '',
      signAsCountersign: '',
      signTypeDisplay: 'Sign',
      showOnlyNeedCountersign: false,
      customInputStyle: customInputStyle,
      acceptCreditCards: '',
      allowMonthlyPlans: '',
      allowAnnualPlans: '',
    }
  }
  componentDidMount() {
    this._isMounted = true;
    this.getPatients()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getPatients(includeClosedAccounts = '', validSignedAgreementStartDate = false, validSignedAgreementEndDate = false, validCanceledStartDate = false, validCanceledEndDate = false) {
    this.setState({
      patientTableData: patientTableDataLoading,
      includeClosedAccountsButtonDisabled: true
    })
    if (includeClosedAccounts === '') {
      includeClosedAccounts = this.state.includeClosedAccounts
    }
    if (validSignedAgreementStartDate === false) {
      validSignedAgreementStartDate = this.state.validSignedAgreementStartDate
    }
    if (validSignedAgreementEndDate === false) {
      validSignedAgreementEndDate = this.state.validSignedAgreementEndDate
    }
    if (validCanceledStartDate === false) {
      validCanceledStartDate = this.state.validCanceledStartDate
    }
    if (validCanceledEndDate === false) {
      validCanceledEndDate = this.state.validCanceledEndDate
    }


    axios.get(`${API_ROOT}/patient/?userId=` + this.state.userId + `&includeClosedAccounts=` + includeClosedAccounts +
                `&signedAgreementStartDate=` + validSignedAgreementStartDate + `&signedAgreementEndDate=` + validSignedAgreementEndDate +
                `&canceledStartDate=` + validCanceledStartDate + `&canceledEndDate=` + validCanceledEndDate +
                `&includeSelf=` + this.state.includeSelfInPatientQuery + `&needCountersign=` + this.state.showOnlyNeedCountersign,
                {headers: getApiHeaders()})
      .then(res => this.setPatients({responseMessage: res.data}));
  }

  setPatients(res) {
    if (this._isMounted) {
      this.setState({
        includeClosedAccountsButtonDisabled: false,
        patientTableData: res.responseMessage.map((prop) => {
          var accountStatus = ''
          var isPrimaryProvider = ''
          if (!prop.acknowledgedAgreementDatetime) {
            accountStatus = this.getNeedToSignAgreementDisplayText(prop.userId, prop.name, prop.phone)
          } else if (!prop.acknowledgedAgreementCountersignDatetime) {
            if (prop.isPrimaryProvider === '1') {
              accountStatus = this.getNeedToCountersignAgreementDisplayText(prop.userId, prop.name, prop.phone)
            } else {
              accountStatus = 'countersign req. by primary dentist'
            }
          } else if (prop.openAccount) {
            accountStatus = 'open'
          } else {
            accountStatus = 'closed'
          }
          if (prop.isPrimaryProvider === '1') {
            isPrimaryProvider = true
          } else {
            isPrimaryProvider = false
          }
          if (prop.validBankAccount === 'I' || prop.validBankAccount === 'F') {
            accountStatus = 'payment account issue'
          }
          return {
            id: prop.userId,
            name: prop.name,
            firstName: prop.firstName,
            lastName: prop.lastName,
            address: addressToOneLine(prop.address1, prop.address2),
            addressCity: prop.city,
            addressState: prop.state,
            addressZip: prop.zip,
            phone: phoneToDisplay(prop.phone),
            openAccount: accountStatus,
            actions: (
              <div>
                {/* use this button to add a like kind of action */}
                <span style={this.state.viewType === 'patient' || this.state.viewType === 'employer' ? { display: 'none' } : {}}>
                <Button
                  justIcon
                  round
                  simple
                  onClick={this.viewPatientCharge.bind(this, prop.userId, prop.name, isPrimaryProvider)}
                  color="success"
                  className="like"
                  id={"viewPatientChargeButton_" + prop.userId}
                >
                  <AttachMoney/>
                </Button>{" "}
                </span>
                <span style={isPrimaryProvider || this.state.viewType === 'patient' || this.state.viewType === 'employer' ? {} : { display: 'none' }}>
                {/* use this button to add a edit kind of action */}
                  <Button
                    justIcon
                    round
                    simple
                    onClick={this.viewPatientInfo.bind(this, prop.userId, prop.name, prop.phone)}
                    color="danger"
                    id={"viewPatientInfoButton_" + prop.userId}
                    className="edit"
                  >
                  <Edit/>
                </Button>{" "}
                </span>
                {/* use this button to add a edit kind of action */}
                <span style={(isPrimaryProvider && this.state.viewType !== 'patient' && this.state.viewType !== 'employer') || prop.userId === this.state.userId ? { display: 'none' } : {}}>
                <Button
                  justIcon
                  round
                  simple
                  onClick={this.updatePatientConfirm.bind(this, prop.userId, prop.name, 'remove')}
                  color="danger"
                  className="edit"
                  id={"removePatientButton_" + prop.userId}
                  name={"removePatientButton_" + prop.userId}
                >
                  <Close/>
                </Button>{" "}
                </span>
                {/* use this button to view family members */}
                <span style={this.state.orgType !== 'patient' ? {} : { display: 'none' }}>
                <Button
                  justIcon
                  round
                  simple
                  onClick={this.viewFamily.bind(this, prop.userId, prop.name)}
                  color="cirrusBlue"
                  className="edit"
                  id={"viewFamilyButton_" + prop.userId}
                  name={"viewFamilyButton_" + prop.userId}
                >
                  <People/>
                </Button>{" "}
                </span>
              </div>
            )
          };
        }),

      });
    }
  }

  updatePatientConfirm(userId, userName, updateAction) {
    var alertTitle = ''
    var alertText = ''
    if (this.state.viewType === 'patient' || this.state.viewType === 'employer') {
      alertTitle = "Are you sure you want to remove " + userName + "?"
      alertText = "If you remove the account for " + userName + ", they will no longer receive any service under Cirrus Dental. "
      alertText += userName + " will have the opportunity to enroll in a subscription separate from your account."
    } else {
      alertTitle = "Are you sure you want to remove " + userName + "?"
      alertText = "If you remove the account for " + userName + ", you will not be able to continue to charge the patient."
    }

    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={alertTitle}
          onConfirm={() => this.updatePatient(userId, userName, updateAction)}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          confirmBtnText="Yes, remove!"
          cancelBtnText="Cancel"
          showCancel
        >
          {alertText}
        </SweetAlert>
      )
    });
  }


  updatePatient(userId, userName, updateAction) {

    var orgType
    var clearInformation
    switch (this.state.orgType) {
      case "patient":
        orgType = "M";
        clearInformation = true
        break;
      case "provider":
        orgType = "P";
        clearInformation = false
        break;
      case "employer":
        orgType = "E";
        clearInformation = true
        break;
      default:
        orgType = ''
        clearInformation = ''
    }

    const updatePatientData = {
      userId: userId,
      orgUserId: this.state.userId,
      orgType: orgType,
      updateAction: updateAction,
      clearInformation: clearInformation
    }
    axios.post(`${API_ROOT}/childAccount/`, updatePatientData, { headers: getApiHeaders() })
      .then(res => this.handleUpdatePatientResponse(res));

  }

  handleUpdatePatientResponse(res) {
    if (this._isMounted) {
      this.setState({
        alert: (
          <SweetAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Removed!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            The patient has been removed.
          </SweetAlert>
        )
      });
      handleApiResponse(res)
      this.getPatients()
    }
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  viewPatientInfo(userId, userName, phone) {
    this.setState({
      patientDialogueOpen: true,
      dialogName: userName,
      dialogUserId: userId,
      dialogPhone: phone,
      nestEggBalance: '',
      pendingBalance: '',
      combinedNestEggPendingBalance: '',
      nestEggBalanceWithBonus: '',
      combinedNestEggPendingBalanceWithBonus: '',
      nestEggBonusAmount: ''
    });
  }

  viewPatientCharge(userId, userName, isPrimaryProvider) {
    this.setState({
      chargeDialogOpen: true,
      dialogName: userName,
      dialogUserId: userId,
      nestEggBalance: '',
      pendingBalance: '',
      combinedNestEggPendingBalance: '',
      nestEggBalanceWithBonus: '',
      combinedNestEggPendingBalanceWithBonus: '',
      nestEggBonusAmount: '',
      isPrimaryProvider: isPrimaryProvider
    });
    this.getPendingCharges(userId);
    this.getRecentCharges(userId);
    this.getPatientAvailableFunds(userId, isPrimaryProvider)
    this.getPatientAccountStatus(userId, true)
  }

  viewFamily(userId, userName) {
    this.setState({
      familyDialogueOpen: true,
      familyUserId: userId,
      dialogName: userName
    })
  }

  handleCloseFamilyDialogue = () => {
    this.setState({
      familyDialogueOpen: false,
      familyUserId: ''
    })
  }
  getPendingCharges(userId) {
    this.setState({
      numPendingCharges: 1,
      pendingCharges: loadingData.map((prop, key) => {
        return {
          id: prop.id,
          transactionDatetime: prop.transactionDatetime,
          transactionAmount: prop.transactionAmount
        };
      })
    });
    //the userId var is patient user we are querying
    //the userId state is the user doing the querying
    //we want to get transactions only between these two users
    axios.get(`${API_ROOT}/financialTransactions/?userId=` + userId + `&transactionType=P&filterBy=from&userToId=` + this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setPendingCharges({responseMessage: res.data}));
  }

  setPendingCharges(res) {
    if (this._isMounted) {
      this.setState({
        numPendingCharges: this.getNumResponseRows(res.responseMessage),
        pendingCharges: res.responseMessage.map((prop, key) => {
          return {
            id: prop.id,
            transactionDatetime: convertToDisplayDate(prop.transactionDatetime),
            transactionAmount: (<span id={"pendingCharge_"+key}>{convertToCurrency(prop.transactionAmount)}</span> ),
            actions: (
              <div>
                {/* use this button to add a edit kind of action */}
                <Button
                  justIcon
                  simple
                  size="sm"
                  onClick={this.deletePendingTransactionConfirm.bind(this, prop.id, prop.transactionAmount)}
                  color="danger"
                  className="edit"
                  id={"deletePendingTransactionButton_" + key}
                >
                  <Close/>
                </Button>{" "}
              </div>
            )
          };
        })
      });
    }
  }

  getRecentCharges(userId) {
    this.setState({
      numRecentCharges: 1,
      recentCharges: loadingData.map((prop, key) => {
        return {
          id: prop.id,
          transactionDatetime: prop.transactionDatetime,
          transactionAmount: prop.transactionAmount
        };
      })
    });
    axios.get(`${API_ROOT}/financialTransactions/?userId=` + userId + `&transactionType=F&limit=5&filterBy=from`, {headers: getApiHeaders()})
      .then(res => this.setRecentCharges({responseMessage: res.data}));
  }

  setRecentCharges(res) {
    if (this._isMounted) {
      this.setState({
        numRecentCharges: this.getNumResponseRows(res.responseMessage),
        recentCharges: res.responseMessage.map((prop, key) => {
          return {
            id: prop.id,
            transactionDatetime: convertToDisplayDate(prop.transactionDatetime),
            transactionAmount: convertToCurrency(prop.transactionAmount),
            transactionCode: prop.code
          };
        })
      });
    }
  }

  getPatientAvailableFunds(userId, isPrimaryProvider) {
    axios.get(`${API_ROOT}/financialTransactionsSummary/?userId=` + userId + `&includeBonusAmount=` + isPrimaryProvider, {headers: getApiHeaders()})
      .then(res => this.setPatientAvailableFunds({responseMessage: res.data}));
  }

  setPatientAvailableFunds(res) {
    if (this._isMounted) {
      this.setState({
        nestEggBalance: res.responseMessage.total,
        pendingBalance: res.responseMessage.debitPending,
        combinedNestEggPendingBalance: res.responseMessage.totalCombined,
        nestEggBalanceWithBonus: res.responseMessage.totalWithBonus,
        nestEggBonusAmount: res.responseMessage.bonusAmount,
        combinedNestEggPendingBalanceWithBonus: res.responseMessage.totalCombinedWithBonus
      });
    }
  }

  getPatientAccountStatus(userId, forCharge = false) {
    axios.get(`${API_ROOT}/accountStatus/?userId=` + userId, {headers: getApiHeaders()})
      .then(res => this.setPatientAccountStatus({responseMessage: res.data}, userId, forCharge));
  }

  setPatientAccountStatus(res, userId, forCharge = false) {
    if (this._isMounted) {
      var openAccount = res.responseMessage.openAccount
      var openAccountMessage = ''
      if (forCharge) {
        var chargeEntryDisabled = ''
        var accountStatusMessage = ''
        if (openAccount) {
          chargeEntryDisabled = false
          accountStatusMessage = ''
        } else {
          chargeEntryDisabled = true
          accountStatusMessage = 'This account is closed. You cannot add any charges to a closed account.'
        }
        this.setState({
          chargeEntryDisabled: chargeEntryDisabled,
          accountStatusMessage: accountStatusMessage
        });
      } else {
        if (!res.responseMessage.acknowledgedDatetime) {
          openAccountMessage = this.getNeedToSignAgreementDisplayText(this.state.dialogUserId, this.state.dialogName, this.state.dialogPhone)
        } else if (openAccount === true) {
          openAccountMessage = 'open'
        } else {
          openAccountMessage = 'closed'
        }
        const newTable = updateTableRow(this.state.patientTableData, userId, 'openAccount', openAccountMessage)
        this.setState({
          patientTableData: newTable
        });
      }
    }
  }

  getNeedToSignAgreementDisplayText(userId, name, phone) {
    var displayText = ''
    if (this.state.actorOrgType === 'patient') {
      displayText = (<div>pending: <Button simple
                                                  size="sm"
                                                  color="cirrusBlue"
                                                               onClick={this.signPatientAgreement.bind(this, userId, name, false)}
                                                               id={"signPatientAgreement_" + userId}>
        sign agreement
      </Button>
      </div>)
    } else {
      displayText = (<div>needs to sign agreement<Button justIcon
                                                               round
                                                               simple
                                                               color="cirrusBlue"
                                                               onClick={this.confirmResendInvitation.bind(this, userId, name, phone)}
                                                               id={"resendPatientAgreement_" + userId}>
                              <MailOutline/>
                            </Button>
                            </div>)
    }
    return displayText
  }

  getNeedToCountersignAgreementDisplayText(userId, name, phone) {
    var displayText = ''
    if (this.state.actorOrgType === 'provider') {
      displayText = (<div>countersign req.: <Button simple
                                           size="sm"
                                           color="cirrusBlue"
                                           onClick={this.signPatientAgreement.bind(this, userId, name, true)}
                                           id={"signPatientAgreement_" + userId}>
        sign agreement
      </Button>
      </div>)
    } else {
      displayText = ('dentist needs to countersign')
    }
    return displayText
  }

  handleShowOnlyNeedCountersignToggle() {
    var newShow = '';
    if (this.state.showOnlyNeedCountersign === true) {
      newShow = false;
    } else {
      newShow = true;
    }
    this.setState({
      showOnlyNeedCountersign: newShow
    });
  }

  getNumResponseRows(res) {
    var numRows;
    if (res.length) {
      numRows = res.length;
    } else {
      numRows = 1;
    }
    return numRows
  }

  handleChargeDialogClose = () => {
    this.setState({ chargeDialogOpen: false });
  };

  handlePatientDialogClose = () => {
    this.getPatientAccountStatus(this.state.dialogUserId, false)
    this.setState({ patientDialogueOpen: false });
  };

  handleRegisterDialogOpen = () => {
    //first, get the provider if needed
    if (this.state.providerId === '') {
      axios.get(`${API_ROOT}/provider/?userId=` + this.state.userId + `&isPrimary=1`, { headers: getApiHeaders() })
        .then(res => this.setProviderAndOpenRegisterDialog({ responseMessage: res.data }));
    } else {
      //otherwise, open the dialogue
      this.setState({ registerDialogueOpen: true });
    }
  };


  handleInviteDialogOpen = () => {
    this.setState({ inviteDialogueOpen: true });
  };

  handleUploadSpreadsheetOpen = () => {
    this.setState({ uploadSpreadsheetDialogueOpen: true });
  };


  setProviderAndOpenRegisterDialog(res) {
    if (this._isMounted) {
      var providerId = ''
      var acceptCreditCards = ''
      var allowMonthlyPlans = ''
      var allowAnnualPlans = ''
      if (res.responseMessage.length > 0) {
        providerId = res.responseMessage[0].userId
        acceptCreditCards = res.responseMessage[0].acceptCreditCards
        allowMonthlyPlans = res.responseMessage[0].allowMonthlyPlans
        allowAnnualPlans = res.responseMessage[0].allowAnnualPlans
      }
      this.setState({
        providerId: providerId,
        acceptCreditCards: acceptCreditCards,
        allowMonthlyPlans: allowMonthlyPlans,
        allowAnnualPlans: allowAnnualPlans,
        registerDialogueOpen: true
      });
    }
  }

  handleRegisterDialogClose = () => {
    this.setState({ registerDialogueOpen: false });
  };

  handleInviteDialogClose = () => {
    this.setState({ inviteDialogueOpen: false });
  };

  handleUploadSpreadsheetClose = () => {
    this.setState({ uploadSpreadsheetDialogueOpen: false });
  };



  handleRegisterSuccess() {
    this.getPatients()
    this.handleRegisterDialogClose()
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Added"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        >
          <span id="childRegisterSuccessMessage">The patient has been added to your account.</span>
        </SweetAlert>
      )
    });
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleChangeSelect = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  handleClosedAccountsToggle = name => event => {
    this.setState({ [name]: event.target.checked });
    this.getPatients(event.target.checked)
  };

  handleShowFilterToggle = name => event => {
    this.setState({ [name]: event.target.checked });

    if (event.target.checked === false && this.state.showingFilteredSubset) {
      this.setState({
        showingFilteredSubset: false,
        validSignedAgreementStartDate: '',
        validSignedAgreementEndDate: '',
        validCanceledStartDate: '',
        validCanceledEndDate: ''
      })
      this.getPatients('','','','','')
    }
  };

  handleDateChange(event, dateType) {
    var dateValue = '';
    if (event instanceof moment) {
      dateValue = event.format("MM/DD/YYYY")
    } else {
      dateValue = event
    }
    this.setState({
      [dateType]: dateValue
    })
  }

  filterPatients() {
    var validSignedAgreementInfo = validateDateFormatAndOrder(this.state.signedAgreementStartDate, this.state.signedAgreementEndDate, 'agreement signed date', true)
    var validCancelInfo = validateDateFormatAndOrder(this.state.canceledStartDate, this.state.canceledEndDate, 'account canceled date', true)

    var alertMessage = ''

    if (validSignedAgreementInfo.alertMessage) {
      alertMessage += validSignedAgreementInfo.alertMessage + ' '
    }
    if (validCancelInfo.alertMessage) {
      alertMessage += validCancelInfo.alertMessage + ' '
    }

    if (alertMessage) {
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="check the dates"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            {alertMessage}
          </SweetAlert>
        )
      });
    } else {

      var showingFilteredSubset = ''

      if (this.state.signedAgreementStartDate || this.state.signedAgreementEndDate || this.state.canceledStartDate || this.state.canceledEndDate) {
        showingFilteredSubset = true
      } else {
        showingFilteredSubset = false
      }


      this.setState({
        validSignedAgreementStartDate: validSignedAgreementInfo.validStartDate,
        validSignedAgreementEndDate: validSignedAgreementInfo.validEndDate,
        validCanceledStartDate: validCancelInfo.validStartDate,
        validCanceledEndDate: validCancelInfo.validEndDate,
        showingFilteredSubset: showingFilteredSubset
      })

      this.getPatients('', validSignedAgreementInfo.validStartDate, validSignedAgreementInfo.validEndDate, validCancelInfo.validStartDate, validCancelInfo.validEndDate)
    }
  }

  enterCharge(e) {
    e.preventDefault();
    if (verifyDecimal(this.state.chargeFee)) {
      this.setState({
        chargeEntryDisabled: true
      })
      const chargeData = {
        userId: this.state.dialogUserId,
        userToId: this.state.userId,
        code: this.state.chargeCode,
        transactionAmount: this.state.chargeFee,
        transactionType: 'P',
        checkBalance: true,
        chargeFlatFee: false
      }
      axios.post(`${API_ROOT}/financialTransactions/`, chargeData, { headers: getApiHeaders() })
        .then(res => this.handleChargeResponse(res, true, false));
    } else {
      this.showChargeEntryError('Enter charge amount', 'Please enter a valid charge amount before proceeding. Use only numbers in the amount field.')
    }
  }

  handleChargeResponse(res, clearEntryFields, closeSwal) {
    if (this._isMounted) {
      if (res.data['error']) {
        var errorMessage = ''
        if (res.data['error'] === 'exceeded available funds') {
          errorMessage += "You have exceeded the patient's available balance by " + convertToCurrency(res.data['nestEgg'] * -1) + "."
          errorMessage += "You can enter a maximum charge of " + convertToCurrency(res.data['maxChargeAmount']) + "."
        }
        this.showChargeEntryError(res.data['error'], errorMessage)
      } else {
        if (closeSwal) {
          this.hideAlert()
        }
        this.getPendingCharges(this.state.dialogUserId)
        this.getPatientAvailableFunds(this.state.dialogUserId, this.state.isPrimaryProvider)
      }
      if (clearEntryFields) {
        this.setState({
          chargeEntryDisabled: false,
          chargeCode: '',
          chargeFee: ''
        })
      }
    }
  }

  showChargeEntryError(title, errorMessage) {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={title}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        >
          {errorMessage}
        </SweetAlert>
      )
    });
  }

  deletePendingTransactionConfirm(tranactionId, tranactionAmount) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure you want to delete the charge?"
          onConfirm={() => this.deletePendingTransaction(tranactionId)}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          confirmBtnText="Yes, delete!"
          cancelBtnText="Cancel"
          showCancel
        >
          If you delete the pending charge for ${tranactionAmount}, the patient account will not be billed this amount.
        </SweetAlert>
      )
    });
  }

  deletePendingTransaction(tranactionId) {
    const chargeData = {
      userId: this.state.dialogUserId,
      userTo_id: this.state.userId,
      transactionId: tranactionId
    }
    axios.delete(`${API_ROOT}/financialTransactions/`, {data: chargeData, headers: getApiHeaders()})
      .then(res => this.handleChargeResponse(res, false, true));

  }

  confirmResendInvitation(userId, userName, phone) {
    var hasCellPhone = checkForCellPhone(phone)

    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={"Resend member agreement to " + userName}
          onConfirm={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          confirmBtnText="Cancel"
        >

          <Button
            id="sendAgreementTextButton"
            color="cirrusBlue"
            onClick={this.resendUserAgreement.bind(this, userId, userName, 'S')}
            style={hasCellPhone ? {} : { display: 'none' }}
          >
            by text
          </Button>
          <Button
            id="sendAgreementEmailButton"
            color="cirrusBlue"
            onClick={this.resendUserAgreement.bind(this, userId, userName, 'E')}
          >
            by email
          </Button>
        </SweetAlert>
      )
    })
  }

  signPatientAgreement(userId, userName, signAsCountersign) {
    var signTypeDisplay = 'Sign'
    if (signAsCountersign) {
      signTypeDisplay = 'Countersign'
    }
    this.setState({
      agreementDialogueOpen: true,
      signForUserId: userId,
      dialogName: userName,
      signAsCountersign: signAsCountersign,
      signTypeDisplay: signTypeDisplay
    })
  }

  handleCloseAgreementDialogue = () => {
    this.setState({
      agreementDialogueOpen: false,
      signForUserId: false
    })
  }

  handleSignAgreement() {
    this.getPatients()
    this.handleCloseAgreementDialogue()
  }

  resendUserAgreement(userId, userName, sendMethod) {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={"Resending agreement to " + userName}
          onConfirm={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          confirmBtnText="Close"
        >
          <CircularProgress
          id="resendingAgreementWaitWheel"
          />
        </SweetAlert>
      )
    })
    const resendAgreementData = {
      userId: userId,
      sendMethod: sendMethod
    }
    axios.post(`${API_ROOT}/sendAgreement/`, resendAgreementData, { headers: getApiHeaders() })
      .then(res => this.setResendUserAgreementResponse(res, userName));
  }

  setResendUserAgreementResponse(res, userName) {
    var titleText = ''
    if (res.status !== '401' && res.data.message === 'success') {
      titleText = "Sent agreement to " + userName
    } else {
      titleText = "There was an issue sending the agreement."
    }


    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={titleText}
          onConfirm={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          confirmBtnText="Close"
        >
        </SweetAlert>
      )
    })

  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        {this.state.alert}
        <Dialog
          open={this.state.patientDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
        >
          <DialogTitle id="form-dialog-title">Edit account for {this.state.dialogName}</DialogTitle>
          <DialogContent id="userProfileDialogue">
            <ProviderInfo
              userId={this.state.dialogUserId}
              editByOrg={this.state.editByOrg}
              inDialog={true}
            />
            <hr />
            <UserProfile
              userId={this.state.dialogUserId}
              userType="patient"
              editByOrg={this.state.editByOrg}
              parentType={this.state.orgType}
              employerId={this.state.employerId}
              inDialog={true}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handlePatientDialogClose} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.familyDialogueOpen}
          onClose={this.handleCloseFamilyDialogue}
          aria-labelledby="form-dialog-title"
          maxWidth='lg'
        >
          <DialogTitle id="form-dialog-title">Add/remove family members for {this.state.dialogName}</DialogTitle>
          <DialogContent id="userProfileDialogue">
            <Patients
              viewType = 'patient'
              overrideUserId = {this.state.familyUserId}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleCloseFamilyDialogue} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.agreementDialogueOpen}
          onClose={this.handleCloseFamilyDialogue}
          aria-labelledby="form-dialog-title"
          maxWidth='lg'
        >
          <DialogTitle id="form-dialog-title">{this.state.signTypeDisplay} member agreement for {this.state.dialogName}</DialogTitle>
          <DialogContent id="userProfileDialogue">
            <Agreement
              signOnBehalfOfChildMember = {true}
              signForUserId = {this.state.signForUserId}
              asPopupWindow = {true}
              postSignFunction = {this.handleSignAgreement.bind(this)}
              signAsCountersign = {this.state.signAsCountersign}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleCloseAgreementDialogue} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
          open={this.state.chargeDialogOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Charges for {this.state.dialogName}</DialogTitle>
          <DialogContent>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <form onSubmit={this.enterCharge}>
                  <Card>
                    <CardHeader color="cirrusBlue" icon>
                      <CardIcon color="cirrusBlue">
                        <AttachMoney />
                      </CardIcon>
                      <h4 className={classes.cardIconTitle}>
                        enter charge - <small>enter a new charge for processing</small>
                      </h4>
                    </CardHeader>
                    <CardBody>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <p>Nest Egg: <span id="nestEggBalance">{convertToCurrency(this.state.nestEggBalanceWithBonus)}</span> (includes {this.state.nestEggBonusAmount * 100}% bonus)</p>
                          <p>Pending charges: <span id="pendingBalance">{convertToCurrency(this.state.pendingBalance)}</span> (may include charges from other dentists)</p>
                          <p>Total available: <span id="totalBalance">{convertToCurrency(this.state.combinedNestEggPendingBalanceWithBonus)}</span> (includes {this.state.nestEggBonusAmount * 100}% bonus)</p>
                          <Danger>{this.state.accountStatusMessage}</Danger>
                        </GridItem>
                      </GridContainer>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <CustomInput
                            labelText="amount"
                            id="chargeFee"
                            formControlProps={{
                              fullWidth: true,
                              margin: "dense"
                            }}
                            inputProps={{
                              onChange: this.handleChange,
                              value: this.state.chargeFee,
                              disabled: this.state.chargeEntryDisabled
                            }}
                            customStyle={this.state.customInputStyle}
                          />
                        </GridItem>
                      </GridContainer>


                      <Button id="enterChargeButton" color="cirrusBlue" className={classes.updateProfileButton} type="submit" disabled={this.state.chargeEntryDisabled}>
                        enter
                      </Button>
                      <Button id="cancelEnterChargeButton" onClick={this.handleChargeDialogClose} color="cirrusBlue">
                        Close
                      </Button>
                      <Clearfix />
                    </CardBody>
                  </Card>
                </form>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="cirrusBlue" icon>
                    <CardIcon color="cirrusBlue">
                      <AttachMoney />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>pending charges</h4>
                  </CardHeader>
                  <CardBody>
                    <MaterialTable
                      title=''
                      columns={[
                        { title: 'Date', field: 'transactionDatetime'},
                        { title: 'Amount', field: 'transactionAmount' },
                        { title: '', field: 'actions'},
                      ]}
                      data={this.state.pendingCharges}
                      options={shortTableOptions}
                      style={tableStyle}
                    />
                  </CardBody>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="cirrusBlue" icon>
                    <CardIcon color="cirrusBlue">
                      <AttachMoney />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>recent charges</h4>
                  </CardHeader>
                  <CardBody>
                    <MaterialTable
                      title=''
                      columns={[
                        { title: 'Date', field: 'transactionDatetime'},
                        { title: 'Amount', field: 'transactionAmount' },
                      ]}
                      data={this.state.recentCharges}
                      options={shortTableOptions}
                      style={tableStyle}
                    />
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleChargeDialogClose} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.registerDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
        >
          <DialogTitle id="form-dialog-title">Register a new member</DialogTitle>
          <DialogContent>
            <RegisterPatient
              asPopup = {true}
              parentPatientId = {this.state.userId}
              registerAsChild = {true}
              postRegisterFunction = {this.handleRegisterSuccess.bind(this)}
              providerId = {this.state.providerId}
              editByOrg = {this.state.editByOrg}
              viewType = {this.state.viewType}
              actorOrgType = {this.state.actorOrgType}
              acceptCreditCards = {this.state.acceptCreditCards}
              allowMonthlyPlans = {this.state.allowMonthlyPlans}
              allowAnnualPlans = {this.state.allowAnnualPlans}
              inDialog = {true}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleRegisterDialogClose} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.inviteDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
        >
          <DialogTitle id="form-dialog-title">Invite an existing member to join {this.state.groupType}</DialogTitle>
          <DialogContent>
            <Invitation
              showHeader = {false}
              orgType = {this.state.orgType}
              invitationFrom = {this.state.orgType}
              inDialog = {true}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleInviteDialogClose} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.uploadSpreadsheetDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
        >
          <DialogTitle id="form-dialog-title-upload">Upload a list of employees</DialogTitle>
          <DialogContent>
            Please upload a csv file with your employees.
            The file should have columns with the following headers:
            <ul>
              <li>first name</li>
              <li>last name</li>
              <li>address</li>
              <li>city</li>
              <li>state</li>
              <li>zip</li>
              <li>email</li>
              <li>phone</li>
            </ul>
            <p>You can also include other columns, but we will ignore them when loading your employee records.</p>
            <p>Depending on the size of the file, it may take up to 30 minutes to process the records.</p>
            <p>We'll email you as soon as we've loaded all the records.</p>

          <FileUpload
            uploadToUserId = {this.state.userId}
            uploadPath = 'registerBatch'
          />

          </DialogContent>

          <DialogActions>
            <input
              accept="text/csv"
              className={classes.input}
              style={{ display: 'none' }}
              id="employeeListFile"
              multiple
              type="file"
            />
            <Button onClick={this.handleUploadSpreadsheetClose} color="cirrusBlue">
              Close
            </Button>

          </DialogActions>
        </Dialog>



          <GridItem xs={12}>
            <Card>
              <CardHeader color="cirrusBlue" icon>
                <CardIcon color="cirrusBlue">
                  <PersonIcon style={this.state.viewType === 'patient' || this.state.viewType === 'employer' ? { display: 'none' } : {}} />
                  <People style={this.state.viewType === 'patient' || this.state.viewType === 'employer' ? {} : { display: 'none' }} />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{this.state.pageTitle}</h4>
              </CardHeader>
              <CardBody>
                <div className={classes.block}>
                  <FormControlLabel
                    control={
                      <Switch
                        disabled={this.state.includeClosedAccountsButtonDisabled}
                        checked={this.state.includeClosedAccounts}
                        onChange={this.handleClosedAccountsToggle("includeClosedAccounts")}
                        value="includeClosedAccounts"
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label="included closed accounts"
                  />
                </div>
                <div className={classes.block} style={this.state.viewType === 'patient' ? { display: 'none' } : {}}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.showFilterOptions}
                        onChange={this.handleShowFilterToggle("showFilterOptions")}
                        value="showFilterOptions"
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label="show/hide filter options"
                  />
                </div>
                <div style={this.state.showFilterOptions ? {} : { display: 'none' }}>
                  <GridContainer style={this.state.showFilterOptions ? {} : { display: 'none' }}>
                    <GridItem xs={2} sm={2} md={1} className={classes.filterLabel}>
                      agreement signed
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}>
                      <InputLabel className={classes.label}>from</InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          onChange={(event) => {this.handleDateChange(event, 'signedAgreementStartDate');}}
                          timeFormat={false}
                          inputProps={{
                            id: "signedAgreementStartDate",
                            value: this.state.signedAgreementStartDate
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}>
                      <InputLabel className={classes.label}>to</InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          onChange={(event) => {this.handleDateChange(event, 'signedAgreementEndDate');}}
                          timeFormat={false}
                          inputProps={{
                            id: "signedAgreementEndDate",
                            value: this.state.signedAgreementEndDate
                          }}
                        />
                      </FormControl>
                    </GridItem>

                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={2} sm={2} md={1} className={classes.filterLabel}>
                      account canceled
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}>
                      <InputLabel className={classes.label}>from</InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          onChange={(event) => {this.handleDateChange(event, 'canceledStartDate');}}
                          timeFormat={false}
                          inputProps={{
                            id: "canceledStartDate",
                            value: this.state.canceledStartDate
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}>
                      <InputLabel className={classes.label}>to</InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          onChange={(event) => {this.handleDateChange(event, 'canceledEndDate');}}
                          timeFormat={false}
                          inputProps={{
                            id: "canceledEndDate",
                            value: this.state.canceledEndDate
                          }}
                        />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={8} sm={8} md={8}>
                      <Checkbox
                        id={'showOnlyNeedCountersign'}
                        onClick={() => this.handleShowOnlyNeedCountersignToggle()}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot
                        }}
                        checked={this.state.showOnlyNeedCountersign}
                        disabled={this.state.inputDisabled}
                      />show only records that need countersignature
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={3} sm={3} md={3}>
                      <Button color="cirrusBlue"  onClick={this.filterPatients.bind(this)} className={classes.updateProfileButton} type="submit">
                        filter
                      </Button>
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={3}>
                      &nbsp;
                    </GridItem>
                  </GridContainer>

                </div>
                <div className={classes.block} style={this.state.viewType === 'patient' || this.state.viewType === 'employer' ? {} : { display: 'none' }}>
                  <Button color="cirrusBlue"
                          onClick={this.handleRegisterDialogOpen.bind(this)}
                          className={classes.updateProfileButton}
                          type="submit"
                          id="addNewMemberToGroup">
                    add new member
                  </Button>
                  <Button color="cirrusBlue"
                          onClick={this.handleInviteDialogOpen.bind(this)}
                          className={classes.updateProfileButton}
                          type="submit"
                          id="addExistingMemberToGroup">
                    add existing member
                  </Button>
                  <span style={this.state.viewType === 'employer' ? {} : { display: 'none' }}>
                    <Button color="cirrusBlue"
                            onClick={this.handleUploadSpreadsheetOpen.bind(this)}
                            className={classes.updateProfileButton}
                            type="submit"
                            id="uploadMemberSpreadsheet">
                      upload employee spreadsheet
                    </Button>
                  </span>
                </div>
                <MaterialTable
                  title=''
                  columns={[
                    { title: 'first name', field: 'firstName'},
                    { title: 'last name', field: 'lastName' },
                    { title: 'address', field: 'address' },
                    { title: 'city', field: 'addressCity' },
                    { title: 'state', field: 'addressState' },
                    { title: 'zip', field: 'addressZip' },
                    { title: 'phone', field: 'phone' },
                    { title: 'status', field: 'openAccount' },
                    { title: 'actions', field: 'actions' },
                  ]}
                  data={this.state.patientTableData}
                  style={tableStyle}
                  options={tableOptions}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

    );
  }
}

export default withStyles(styles)(ReactTables);
